import { PureComponent, Component, Fragment, useEffect } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useState, useRef } from 'react';
import Joyride from 'react-joyride';
import { Formik } from 'formik';
import moment from 'moment';
import { AvForm, AvField } from 'availity-reactstrap-validation';

import {
  Grid,
  Dropdown,
  Modal,
  Button,
  Icon,
  Segment,
  Search,
  Form,
} from 'semantic-ui-react';

import {
  getInvitations,
  getOwnActivities,
  getInvitedActivities,
  clearCurrentActivity,
  acceptInvitation,
  postActivity,
  deleteActivity,
  getUserActivityGroups,
  helpTips,
  postDuplicateActivity,
  getDuplicateParentInfo,
  getAllGoals,
  getPolicies,
  getOutcomes,
  postActivityGroup,
  deleteProjectGroup,
  updateProjectGroupRename,
  setUserOnboardingOption,
  setVisibleTips,
  setSidebarType,
} from '../../../store/actions';

import {
  CustomSegment,
  EmptyContainer,
  CustomTable,
  Tooltip,
  BeaconComponent,
  FeatureWrapper,
} from '../../../components';

import addIcon from '../../../assets/add-icon.svg';
import ActivityListTable, { hasLinkedActivities } from './ActivityListTable';

import {
  isEmpty,
  map,
  compact,
  find,
  filter,
  uniq,
  includes,
  size,
  debounce,
} from '../../../utils/lodash';

import {
  getActivityDescription,
  getActivityStatus,
  getActivityType,
  stopPropagation,
  threeDotSeparator,
} from '../../../utils';
import { NotificationManager } from 'react-notifications';

import './activity.scss';
import { isBrowser, isTablet } from 'react-device-detect';

import MessageComponent from '../../../components/message';
import AvRadioGroup from 'availity-reactstrap-validation/lib/AvRadioGroup';
import AvRadio from 'availity-reactstrap-validation/lib/AvRadio';
import { isFeature } from '../../../utils/activity/userPermission';
import {
  newActivityInitialValues,
  NewActivityValidationSchema,
} from '../../../validations/newActivityRecordValidation';
import { CustomDropdown, CustomInput } from '../../../components/form';
import { SIDEBAR_TYPES } from '../../../utils/constant';

const ActivityForm = (props) => {
  const { t } = useTranslation();
  const [planType, setPlanType] = useState(null);
  const navigate = useNavigate();

  const handleValidSubmit = async (values, setSubmitting) => {
    try {
      const {
        postActivity,
        user: {
          organisation: { settings = [] },
        },
      } = props;
      const [config = {}] = settings;
      const { crossReferenceLabel, crossReferenceDocument, cultureCounts } =
        config;

      if (!isSingleActivity()) {
        values.activityPlanTypeId = 1;
      }

      if (crossReferenceDocument && crossReferenceLabel) {
        values.referenceCodeLabel = crossReferenceLabel;
        values.referenceDocument = crossReferenceDocument;
      }
      values.isCultureCount = cultureCounts ? true : false;
      const actID = await postActivity(values);
      setSubmitting(false);
      navigate(`/activities/${actID}/goal`);
    } catch (error) {
      console.error('ActivityForm ~ handleValidSubmit ~ error', error);
      setSubmitting(false);
    }
  };

  const onChangePlayType = (value) => {
    setPlanType(value);
  };

  const isSingleActivity = () => {
    const getTypes = getPlanTypes();
    const result = getTypes.filter((type) => type.name === 'Single Activity');
    const typeLength = getTypes.length <= 1;
    return typeLength === true && !isEmpty(result) === true ? false : true;
  };

  const getPlanTypes = () => {
    const { actPlanTypes, user } = props;
    const types = map(actPlanTypes, (plan, i) => {
      // TODO:i18n
      // TODO: conditionals based on names is YUCK!!!! change...
      if (
        plan.name === t('activity_type.single_activity') &&
        !isFeature(user, 'single_program')
      )
        return null;
      if (
        plan.name === t('activity_type.grants_program') &&
        !isFeature(user, 'grant_program')
      )
        return null;
      if (
        plan.name === t('activity_type.festival_program') &&
        !isFeature(user, 'festival_program')
      )
        return null;
      if (
        plan.name === t('activity_type.multi_activity_program') &&
        !isFeature(user, 'multi_activity_program')
      )
        return null;

      return {
        key: i,
        value: plan.id,
        text: plan.name,
      };
    });
    return compact(types);
  };

  const { actPostLoading } = props;
  const getTypes = getPlanTypes();

  return (
    <Formik
      initialValues={newActivityInitialValues}
      validationSchema={NewActivityValidationSchema(t)}
      onSubmit={(values, { setSubmitting }) => {
        handleValidSubmit(values, setSubmitting);
      }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit} className="new-activity-record">
          <CustomInput
            name="name"
            id="name"
            labelText={t('common.activity_name')}
            placeholder={t('formulary.placeholder.enter_activity_name')}
            autoComplete="off"
          />

          {isSingleActivity() && (
            <CustomDropdown
              search
              selection
              labelText={t('common.activity_type')}
              placeholder={t('formulary.placeholder.select_activity_type')}
              name="activityPlanTypeId"
              id="activityPlanTypeId"
              getValue={(value) => {
                onChangePlayType(value);
              }}
              options={getPlanTypes()}
            />
          )}

          {planType && (
            <div className="sub-label add-bottom">
              {getActivityDescription(planType)}
              {''}
            </div>
          )}
          <div className="model-btn-align-right">
            <Button
              loading={actPostLoading}
              disabled={isEmpty(getTypes) ? true : actPostLoading}
              content={t('actions.save')}
              type="submit"
              className="Primary-Button"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

class ActivityCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { t } = this.props;
    const { modal } = this.state;

    return (
      <div className="add-goal">
        <Modal
          trigger={
            /*
             * Note:  add-activity class name used for help tip showing class name (don't change it or remove it)
             */
            <Button
              onClick={() => this.toggle()}
              className="Primary-Button add-activity"
            >
              <div className="add-icon-activity-add">
                <img className="icons-add" src={addIcon} alt="icon" />
                <div className="add-text">
                  {t('activity.home.create.add_button')}
                </div>
              </div>
            </Button>
          }
          size="tiny"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="new-activity-record"
        >
          <Modal.Header>{t('activity.home.create.modal_title')}</Modal.Header>
          <Modal.Content>
            <ActivityForm toggle={() => this.toggle()} {...this.props} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

// Dates in the activity lists: day + month, with the year in brackets only when it isn't the current year — "Sep 22" / "Nov 23 (2022)".
const isThisYear = (date) => date.getFullYear() === new Date().getFullYear();
const dayMonthFormat = (language) =>
  new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short' });
const yearSuffix = (date) =>
  isThisYear(date) ? '' : ` (${date.getFullYear()})`;

// Date Created cell
const formatListDate = (value, language) => {
  const date = new Date(value);
  return `${dayMonthFormat(language).format(date)}${yearSuffix(date)}`;
};

const parseDateOnly = (value) => {
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day);
};

// Activity Dates cell e.g. "Sep 1", "Sep 10 – 29", "Nov 15 – 29 (2025)", "Dec 20 – Jan 10 (2025–2026)"
const renderActivityDates = (data, language, t) => {
  if (!data.eventStartDate) {
    return (
      <span className="activity-list-table__no-dates">
        {t('activity.home.dates_not_set')}
      </span>
    );
  }
  const start = parseDateOnly(data.eventStartDate);
  const end = data.eventEndDate ? parseDateOnly(data.eventEndDate) : null;
  const format = dayMonthFormat(language);

  if (!end || end <= start)
    return `${format.format(start)}${yearSuffix(start)}`;

  // same year: let formatRange collapse the repeated month ("Nov 15 – 29")
  if (start.getFullYear() === end.getFullYear()) {
    return `${format.formatRange(start, end)}${yearSuffix(start)}`;
  }
  // across years formatRange forces the years inline... so overide that
  return `${format.format(start)} – ${format.format(
    end
  )} (${start.getFullYear()}–${end.getFullYear()})`;
};

const isOwnActivity = (activity, user) =>
  Number(activity.owner?.id) === Number(user.id);

// Name cell for the Managed / Invited lists (TAK-2036). Program rows show how
// many activities they hold; activities inside a program say who runs them
// when it isn't the viewer; a top-level linked activity (its program isn't
// listed above it) gets a "Part of <program>" line instead.
const renderActivityName = (data, ctx, href, { t, user, isManagedList }) => {
  const parent = ctx.level === 0 ? data.parentActivity : null;
  const parentOwner =
    parent && parent.owner && Number(parent.owner.id) !== Number(user.id)
      ? parent.owner.name
      : null;

  // Program: "20 activities", plus a breakdown only when some are the
  // viewer's and some aren't — "(4 managed by yourself, 16 managed by others)"
  let linkedSummary = null;
  if (hasLinkedActivities(data)) {
    const total = data.linkedActivities.length;
    const own = data.linkedActivities.filter((child) =>
      isOwnActivity(child, user)
    ).length;
    linkedSummary = t('activity.home.program_list.linked_count', {
      count: total,
    });
    if (own > 0 && own < total) {
      linkedSummary += ` ${t('activity.home.program_list.linked_breakdown', {
        own,
        others: total - own,
      })}`;
    }
  }

  // Name the activity manager when it isn't the viewer
  const managedBy =
    (ctx.level > 0 || isManagedList) && data.owner && !isOwnActivity(data, user)
      ? t('activity.home.program_list.activity_managed_by', {
          name: data.owner.name,
        })
      : null;

  return (
    <div className="activity-name">
      <div
        className={`circle circle-bottom activity-${getActivityStatus(
          data.statusId
        )}`}
      />
      <div className="activity-list-table__name">
        <label>
          <Link to={href} className="enter-activity-link">
            {data.name ? data.name : ''}
          </Link>
        </label>
        {linkedSummary || managedBy ? (
          <span className="activity-list-table__meta">
            {linkedSummary}
            {linkedSummary && managedBy ? ' · ' : null}
            {managedBy}
          </span>
        ) : null}
        {parent ? (
          <span className="activity-list-table__part-of">
            {t('activity.home.program_list.part_of')} <b>{parent.name}</b>
            {parentOwner
              ? ` · ${t('activity.home.program_list.program_managed_by', {
                  name: parentOwner,
                })}`
              : null}
          </span>
        ) : null}
      </div>
    </div>
  );
};

// Type cell: linked activities inside a program block don't repeat "Linked
// Activity" (the block already shows the link), but a program nested inside
// another program still shows its own program type.
const renderActivityTypeCell = (data, ctx, t) => {
  if (ctx.level === 0) return getActivityType(data).type;
  if (!hasLinkedActivities(data)) return null;
  return getActivityType({ ...data, isLinkedActivity: false }).type;
};

/**
 * Before duplicating, checks whether the activity's goal is still one of the
 * organisation's goals, or another goal shares its policy domains. Returns the
 * state the DuplicateModal needs. Shared by the Managed and Invited lists.
 */
const duplicationGoalState = (goals, data) => {
  // TODO: why tf are we searching on goal title? and not id? that's crazy
  const available = find(goals, { goalTitle: data.goal });

  let goalsPolicyMatching = [];

  for (const policy of goals) {
    if (policy.primaryPolicyId === data.primaryPolicyId) {
      if (!data.secondaryPolicyId) {
        goalsPolicyMatching.push(policy);
      } else {
        // secondary domain may be stored as a direct FK or via the M:M join table
        const findItem =
          policy.secondaryPolicyId === data.secondaryPolicyId ||
          find(policy.secondaryPolicies, { id: data.secondaryPolicyId });
        if (findItem) {
          goalsPolicyMatching.push(policy);
        }
      }
    } else if (
      policy.primaryPolicyId === data.secondaryPolicyId &&
      data.secondaryPolicyId
    ) {
      const findItem =
        policy.secondaryPolicyId === data.primaryPolicyId ||
        find(policy.secondaryPolicies, { id: data.primaryPolicyId });
      if (findItem) {
        goalsPolicyMatching.push(policy);
      }
    }
  }

  if (isEmpty(available)) {
    if (isEmpty(goalsPolicyMatching)) {
      // no longer used by org and not same policy domains
      return {
        singleData: data,
        notMatchingDomains: true,
        matchingDomains: false,
        available: false,
      };
    }
    // no longer used by org and same policy domains
    return {
      singleData: data,
      matchingDomains: true,
      notMatchingDomains: false,
      goalsPolicyMatching: uniq(goalsPolicyMatching),
      available: false,
    };
  }

  const checkSecondary = find(available.secondaryPolicies, {
    id: data.secondaryPolicies,
  });
  if (
    available.primaryPolicyId !== data.primaryPolicyId &&
    isEmpty(checkSecondary)
  ) {
    return {
      singleData: data,
      notMatchingDomains: true,
      available: false,
      matchingDomains: false,
    };
  }
  return {
    singleData: data,
    available: true,
    notMatchingDomains: false,
    matchingDomains: false,
  };
};

class InvitedActivities extends PureComponent {
  constructor(props) {
    super(props);
    // TAK-2080: the same duplicate state the Managed list keeps
    this.state = {
      available: false,
      matchingDomains: false,
      notMatchingDomains: false,
      goalsPolicyMatching: [],
      singleData: '',
    };
  }

  async componentDidMount() {
    // TAK-2080: the duplicate goal check needs the organisation's goals,
    // which the Managed list loads — but it isn't shown when you manage none.
    const { goals, getAllGoals, getPolicies, getOutcomes } = this.props;
    if (isEmpty(goals)) {
      await Promise.all([getAllGoals(), getPolicies(), getOutcomes()]);
    }
  }

  checkGoalAvailableForDuplication(data) {
    this.setState(duplicationGoalState(this.props.goals, data));
  }

  renderColumns() {
    const { t, i18n, attributeName, user } = this.props;
    let name = attributeName.invited;

    return [
      {
        title: (
          <div className="sort-icon">
            <div className="lib-header">{t('common.name')}</div>
            <Icon
              className="icon-adjustment"
              name={name === 'name' ? this.getIcon() : 'sort'}
              onClick={(value) => this.props.sortInvitedActivities('name')}
            />
          </div>
        ),
        render: (data, ctx) =>
          renderActivityName(data, ctx, `/activities/${data.id}`, { t, user }),
      },
      {
        className: 'activity-list-table__col--type',
        title: t('common.type'),
        render: (data, ctx) => renderActivityTypeCell(data, ctx, t),
      },
      {
        className: 'activity-list-table__col--owner',
        title: t('common.owner'),
        textAlign: 'left',
        render: (data) => {
          return data.owner && data.owner.name ? data.owner.name : '-';
        },
      },
      {
        className: 'activity-list-table__col--date',
        title: (
          <div className="sort-icon">
            <div>{t('common.date_created')}</div>
            <Icon
              className="icon-adjustment"
              name={name === 'createdDateTime' ? this.getIcon() : 'sort'}
              onClick={(value) =>
                this.props.sortInvitedActivities('createdDateTime')
              }
            />
          </div>
        ),
        render: (data) => {
          return formatListDate(data.createdDateTime, i18n.language);
        },
      },
      {
        className: 'activity-list-table__col--dates',
        title: (
          <div className="sort-icon">
            <div>{t('activity.home.activity_dates')}</div>
            <Icon
              className="icon-adjustment"
              name={name === 'eventStartDate' ? this.getIcon() : 'sort'}
              onClick={(value) =>
                this.props.sortInvitedActivities('eventStartDate')
              }
            />
          </div>
        ),
        render: (data) => renderActivityDates(data, i18n.language, t),
      },
      {
        className: 'activity-list-table__col--menu',
        render: (data) => {
          const { t } = this.props;

          return (
            <div className="invited">
              <Dropdown
                icon="ellipsis vertical"
                direction="left"
                inline
                selectOnBlur={false}
              >
                <Dropdown.Menu>
                  {this.props.user.role !== 'guest' ? (
                    <Dropdown.Item
                      as="a"
                      href={`/activity/${data.id}/preview`}
                      target="_blank"
                    >
                      <label className="black-text">
                        {t('actions.view_report')}
                      </label>
                    </Dropdown.Item>
                  ) : null}
                  {/* TAK-2080: a member allowed to duplicate gets the same
                      Duplicate as the manager; the copy is theirs */}
                  {data.canDuplicate ? (
                    <FeatureWrapper
                      featureName="duplicate_activity"
                      children={
                        <DuplicateModal
                          notMatchingDomains={this.state.notMatchingDomains}
                          matchingDomains={this.state.matchingDomains}
                          goalsPolicyMatching={this.state.goalsPolicyMatching}
                          {...this.props}
                          data={this.state.singleData}
                          available={this.state.available}
                          trigger={
                            <Dropdown.Item
                              className="dropdown-customItem"
                              onClick={() =>
                                this.checkGoalAvailableForDuplication(data)
                              }
                            >
                              <div className="black-text">
                                {t('activity.home.owned.duplicate')}
                              </div>
                            </Dropdown.Item>
                          }
                        />
                      }
                    />
                  ) : null}
                  <Dropdown.Item
                    as="a"
                    href={`mailto:${data.owner.email}?subject=Request withdrawal from activity - ${data.name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <label className="remove-activity ">
                      {t('activity.home.invited.request_withdrawal')}
                    </label>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    ];
  }

  getIcon() {
    const { order } = this.props;
    if (order.invited === 'asc') {
      return 'sort up';
    } else {
      return 'sort down';
    }
  }

  pageChange(page) {
    const {
      getInvitedActivities,
      filter,
      actType,
      setPage,
      attributeName,
      order,
      searchQuery,
      perPage,
    } = this.props;
    getInvitedActivities(
      filter.invited,
      actType.invited,
      page,
      perPage,
      attributeName.invited,
      order.invited,
      searchQuery.invited
    );
    setPage(page);
  }

  render() {
    const { data, currentPage } = this.props;
    return (
      <ActivityListTable
        columns={compact(this.renderColumns())}
        currentUserId={this.props.user.id}
        data={data.docs}
        getRowHref={(item) => `/activities/${item.id}`}
        onPageChange={(page) => this.pageChange(page)}
        page={currentPage}
        noOfPages={data.pages}
      />
    );
  }
}

class ActivityDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async deleteActivity(id) {
    const { t } = this.props;

    try {
      const { filter, actType, deleteActivity, page, group } = this.props;
      await deleteActivity(id, filter.owned, actType.owned, group.owned, page);
      this.toggle();
    } catch (error) {
      NotificationManager.error(
        t('activity.errors.couldnt_delete_activity'),
        t('common.something_went_wrong')
      );
    }
  }

  render() {
    const { modal } = this.state;
    const { t, activity, trigger } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="mini"
        trigger={trigger}
      >
        <Modal.Header>
          {threeDotSeparator({
            name: activity.name,
            length: 33,
            prefix: t('activity.home.delete.title'),
            separator: '-',
            isPopUp: true,
          })}
        </Modal.Header>
        <Modal.Content>
          <p>{t('activity.home.delete.confirm')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button className="modal-cancel" onClick={() => this.toggle()}>
            {t('actions.no')}
          </Button>
          <Button
            className="modal-proceed"
            onClick={() => this.deleteActivity(activity.id)}
          >
            {t('actions.yes')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

class GroupUnAssign extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async unAssignGroup(id) {
    const { t } = this.props;

    try {
      const { filter, actType, postActivityGroup, page, group, user } =
        this.props;
      const values = { unassign: true };

      await postActivityGroup(
        id,
        values,
        user.id,
        filter,
        actType,
        group,
        page
      );
      this.toggle();
    } catch (error) {
      NotificationManager.error(
        t('activity.errors.couldnt_unassign_the_group'),
        t('common.something_went_wrong')
      );
    }
  }

  render() {
    const { modal } = this.state;
    const { t, data, trigger } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="mini"
        trigger={trigger}
      >
        <Modal.Header>{t('activity.group_unassign.title')}</Modal.Header>
        <Modal.Content>
          <p>{t('activity.group_unassign.confirm')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.toggle()} className="modal-cancel">
            {t('actions.no')}
          </Button>
          <Button
            onClick={() => this.unAssignGroup(data.id)}
            className="modal-proceed"
            content={t('actions.yes')}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

class AddToGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t, data, trigger } = this.props;
    return (
      <Modal
        open={modal}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={(e) => this.toggle(e)}
            name="close"
            className="closeicon"
          />
        }
        size="tiny"
        trigger={trigger}
      >
        <Modal.Header>
          {data.projectGroupId === null
            ? t('activity.home.group_add.title')
            : t('activity.home.group_change.title')}
        </Modal.Header>
        <Modal.Content>
          <GroupForm toggle={() => this.toggle()} {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}

class GroupForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExistingGroup: true,
      edit: false,
    };
  }

  async handleValidSubmit(event, values) {
    const { t } = this.props;

    try {
      const {
        postActivityGroup,
        data,
        toggle,
        user,
        filter,
        actType,
        group,
        currentPage,
      } = this.props;

      const { edit } = this.state;

      delete values.groupSelect;

      if (edit) {
        values.name = values.newName;
        delete values.newName;
      }

      await postActivityGroup(
        data.id,
        values,
        user.id,
        filter,
        actType,
        group,
        currentPage
      );

      toggle();
    } catch (error) {
      NotificationManager.error(
        t('activity.errors.couldnt_submit_activity'),
        t('common.something_went_wrong')
      );
    }
  }

  renderGroups() {
    return map(this.props.projectGroup, (item, i) => (
      <option key={i} value={item.id}>
        {item.name}
      </option>
    ));
  }

  selectType(value) {
    this.setState({
      isExistingGroup: value === 'existingGroup' ? true : false,
    });
  }

  componentWillMount() {
    const { data } = this.props;

    if (data.projectGroupId !== null) {
      this.setState({
        edit: true,
      });
    }
  }

  render() {
    const { t, toggle, data, groupAddLoading } = this.props;
    const { isExistingGroup, edit } = this.state;

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        autoComplete="off"
        model={edit ? data : null}
      >
        <AvRadioGroup
          inline
          name="groupSelect"
          required
          className="group-bg"
          value={isExistingGroup ? 'existingGroup' : 'newGroup'}
        >
          <AvRadio
            label={t('activity.home.group_form.existing')}
            value="existingGroup"
            onChange={(e) => this.selectType(e.target.value)}
          />
          <AvRadio
            label={t('activity.home.group_form.new')}
            value="newGroup"
            onChange={(e) => this.selectType(e.target.value)}
          />
        </AvRadioGroup>

        {isExistingGroup ? (
          <AvField
            label={t('activity.home.group_form.select_existing')}
            className="org-inputs"
            name="projectGroupId"
            type="select"
            validate={{
              required: {
                value: true,
                errorMessage: t('activity.home.group_form.required_existing'),
              },
            }}
          >
            <option value="" disabled defaultValue>
              {t('activity.home.group_form.select_placeholder')}
            </option>
            {this.renderGroups()}
          </AvField>
        ) : null}

        {!isExistingGroup ? (
          <AvField
            label={t('activity.home.group_form.new_name')}
            className="org-inputs"
            name={edit ? 'newName' : 'name'}
            type="text"
            validate={{
              required: {
                value: true,
                errorMessage: t('activity.home.group_form.name_required'),
              },
            }}
            autoComplete="off"
          />
        ) : null}

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.save')}
            type="submit"
            className="Primary-Button"
            loading={groupAddLoading}
            disabled={groupAddLoading}
          />
        </div>
      </AvForm>
    );
  }
}

class DuplicateModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      parentInfo: null,
      parentInfoLoading: false,
      keepInProgram: false,
    };
  }

  toggle() {
    this.setState({ modal: !this.state.modal, keepInProgram: false });
  }

  // The row's data arrives as a prop in the same click that opens the
  // modal, so it isn't available yet inside toggle(). Load the parent
  // program once the modal is open and has the activity it's for.
  componentDidUpdate(prevProps, prevState) {
    const { data } = this.props;
    const opened = this.state.modal && !prevState.modal;
    const dataChanged = this.state.modal && prevProps.data?.id !== data?.id;
    if (opened || dataChanged) {
      this.loadParentInfo();
      if (data && data.isLinkedActivity) {
        this.setState({ keepInProgram: true });
      }
    }
  }

  async loadParentInfo() {
    const { data, getDuplicateParentInfo } = this.props;
    if (!data || !data.isLinkedActivity) {
      this.setState({ parentInfo: null, parentInfoLoading: false });
      return;
    }
    this.setState({ parentInfoLoading: true });
    const parentInfo = await getDuplicateParentInfo(data.id);
    this.setState({ parentInfo, parentInfoLoading: false });
  }

  render() {
    const { modal, parentInfo, parentInfoLoading, keepInProgram } = this.state;
    const { t, trigger, available, data } = this.props;
    // Keeping a linked activity in its program keeps the original goal, so
    // the goal check (and goal picker) only applies to standalone copies.
    const skipGoalCheck =
      Boolean(data && data.isLinkedActivity) && keepInProgram;
    const showSimpleForm = available || skipGoalCheck;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size={showSimpleForm ? 'tiny' : 'small'}
        trigger={trigger}
      >
        <Modal.Header>
          <div className="header-goal-duplicate">
            {showSimpleForm
              ? t('activity.home.duplicate.title')
              : t('activity.home.duplicate.goal')}
          </div>
        </Modal.Header>
        <Modal.Content>
          <DuplicateForm
            toggle={() => this.toggle()}
            parentInfo={parentInfo}
            parentInfoLoading={parentInfoLoading}
            keepInProgram={keepInProgram}
            setKeepInProgram={(value) =>
              this.setState({ keepInProgram: value })
            }
            skipGoalCheck={skipGoalCheck}
            {...this.props}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

const DuplicateForm = (props) => {
  const { t } = useTranslation();
  const [selectedGoal, setSelectedGoal] = useState('');
  const [secondaryPolicyId, setSecondaryPolicyId] = useState('');
  const [secondaryPolicyName, setSecondaryPolicyName] = useState('');
  const [primaryPolicyId, setPrimaryPolicyId] = useState('');
  const [primaryPolicyName, setPrimaryPolicyName] = useState('');
  const [goalDescription, setGoalDescription] = useState('');

  const navigate = useNavigate();
  const formRef = useRef(null);

  const {
    goals,
    policies,
    data,
    parentInfo,
    parentInfoLoading,
    keepInProgram,
    setKeepInProgram,
    skipGoalCheck,
  } = props;

  useEffect(() => {
    if (!selectedGoal) {
      setPrimaryPolicyId('');
      setPrimaryPolicyName('');
      setSecondaryPolicyId('');
      setSecondaryPolicyName('');
      setGoalDescription('');
      return;
    }
    const getGoal = find(goals, { id: parseInt(selectedGoal) });
    if (!getGoal) return;

    setGoalDescription(getGoal.goalDescription || '');

    const primary = find(policies, { id: getGoal.primaryPolicyId });
    if (primary) {
      setPrimaryPolicyId(primary.id);
      setPrimaryPolicyName(primary.policyName);
    }

    let secondary = {};
    for (const item of getGoal.secondaryPolicies || []) {
      if (data.primaryPolicyId !== getGoal.primaryPolicyId) {
        if (item.id === data.primaryPolicyId) {
          secondary = { ...item };
        }
      } else {
        if (item.id === data.secondaryPolicyId) {
          secondary = { ...item };
        }
      }
    }
    const secondaryPol = find(policies, { id: secondary.id });
    if (secondaryPol) {
      setSecondaryPolicyId(secondaryPol.id);
      setSecondaryPolicyName(secondaryPol.policyName);
    } else {
      setSecondaryPolicyId('');
      setSecondaryPolicyName('');
    }
  }, [selectedGoal, goals, policies, data]);

  const parentArchived =
    Boolean(parentInfo) && Number(parentInfo.statusId) === 3;

  const handleValidSubmit = async (event, values) => {
    try {
      const { postDuplicateActivity, data } = props;

      const { goalsPolicyMatching, available } = props;

      const goalName = find(goalsPolicyMatching, {
        id: parseInt(selectedGoal),
      });

      let allData = {};

      if (available || skipGoalCheck) {
        // No goal sent: the server keeps the source activity's goal.
        allData.name = values.name;
      } else {
        if (!goalName) {
          return;
        }
        allData.name = values.name;
        allData.primaryPolicyId = primaryPolicyId;
        allData.secondaryPolicyId = secondaryPolicyId;
        allData.goal = goalName.goalTitle;
        allData.goalDescription = goalDescription;
      }

      allData.keepLinked = Boolean(data.isLinkedActivity) && keepInProgram;

      const actID = await postDuplicateActivity(data.id, allData);

      navigate(`/activities/${actID}/goal?duplicate=true`);
    } catch (error) {
      console.error('DuplicateForm ~ handleValidSubmit ~ error', error);
    }
  };

  const renderGoals = () => {
    const { goalsPolicyMatching } = props;
    return map(goalsPolicyMatching, (item, i) => (
      <option key={i} value={item.id}>
        {item.goalTitle}
      </option>
    ));
  };

  const setGoal = (value) => {
    setSelectedGoal(value);
  };

  const renderPrimaryPolicy = () => {
    if (!primaryPolicyName) return null;
    return <div className="policy-duplicate">{primaryPolicyName}</div>;
  };

  const renderSecondaryPolicy = () => {
    if (!secondaryPolicyName) return null;
    return <div className="policy-duplicate">{secondaryPolicyName}</div>;
  };

  const renderGoalDescription = () => {
    if (!goalDescription) return null;
    return goalDescription;
  };

  const renderObjectiveDomainOne = () => {
    const { outcomes, t } = props;

    const objectives = filter(outcomes, { policyId: primaryPolicyId });

    if (isEmpty(objectives)) return null;

    return (
      <div className="objective-list-goal-container">
        <label className="objective-list-goal-header">
          {t('activity.home.duplicate.primary_domain_objectives', {
            policy_name: primaryPolicyName || '',
          })}
        </label>
        {map(objectives, (item, i) => {
          if (!item.isEnable) return null;
          return (
            <label className="objective-list-goal-list" key={i}>
              &#8226; {item.title}
            </label>
          );
        })}
      </div>
    );
  };

  const renderObjectiveDomainTwo = () => {
    const { outcomes, t } = props;
    const objectives = filter(outcomes, { policyId: secondaryPolicyId });

    if (isEmpty(objectives)) return null;

    return (
      <div className="objective-list-goal-container">
        <label className="objective-list-goal-header">
          {t('activity.home.duplicate.secondary_domain_objectives', {
            policy_name: secondaryPolicyName || '',
          })}
        </label>
        {map(objectives, (item, i) => {
          if (!item.isEnable) return null;
          return (
            <label className="objective-list-goal-list" key={i}>
              &#8226; {item.title}
            </label>
          );
        })}
      </div>
    );
  };

  const {
    toggle,
    notMatchingDomains,
    matchingDomains,
    available,
    duplicateActLoading,
  } = props;

  // The goal check only applies to standalone copies — a linked activity
  // kept in its program keeps its original goal (skipGoalCheck).
  const goalCheckBlocks = notMatchingDomains && !skipGoalCheck;
  const showGoalPicker = matchingDomains && !skipGoalCheck;
  const showNameField = available || skipGoalCheck || showGoalPicker;
  const showSelectedGoal = Boolean(selectedGoal) && !skipGoalCheck;

  return (
    <div>
      {notMatchingDomains && !data.isLinkedActivity ? (
        <MessageComponent
          msg={t('activity.home.duplicate.unable_to_duplicate')}
          color="red"
        />
      ) : (
        <AvForm
          ref={formRef}
          onValidSubmit={(event, values) => handleValidSubmit(event, values)}
        >
          {data.isLinkedActivity ? (
            <div className="duplicate-link-choice">
              <Form.Field>
                <Form.Radio
                  label={t(
                    'activity.duplicate.duplicate_as_a_standalone_activity'
                  )}
                  checked={!keepInProgram}
                  onChange={() => setKeepInProgram(false)}
                />
              </Form.Field>
              <Form.Field disabled={parentInfoLoading || parentArchived}>
                <Form.Radio
                  label={
                    parentInfo
                      ? t('activity.duplicate.keep_in_program_linked_to', {
                          parentName: parentInfo.name,
                        })
                      : t('activity.duplicate.keep_in_program')
                  }
                  checked={keepInProgram}
                  onChange={() => setKeepInProgram(true)}
                />
              </Form.Field>
              {parentArchived ? (
                <MessageComponent
                  msg={t('activity.unarchive_parent_before_duplicating', {
                    parentName: parentInfo.name,
                  })}
                  color="red"
                />
              ) : null}
            </div>
          ) : null}

          {goalCheckBlocks ? (
            <MessageComponent
              msg={t('activity.home.duplicate.unable_to_duplicate')}
              color="red"
            />
          ) : null}

          {showGoalPicker ? (
            <Fragment>
              <MessageComponent
                msg={t('activity.home.duplicate.created_with_previous_goal')}
                color="red"
              />
              <br />
            </Fragment>
          ) : null}

          {showNameField ? (
            <AvField
              type="text"
              name="name"
              label={t('activity.home.duplicate.new_activity_name')}
              className="org-inputs"
              value={`${data.name} (Copy)`}
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'activity.home.duplicate.new_activity_required'
                  ),
                },
              }}
            ></AvField>
          ) : null}

          <Grid>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                {showGoalPicker ? (
                  <AvField
                    className="act-inputs"
                    type="select"
                    name="primary"
                    label={<div>{t('formulary.placeholder.select_goal')}</div>}
                    onChange={(e) => setGoal(e.target.value)}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t('formulary.validation.required'),
                      },
                    }}
                  >
                    <option value="">
                      {t('formulary.placeholder.select_a_goal')}
                    </option>
                    {renderGoals()}
                  </AvField>
                ) : null}
              </Grid.Column>
              {showSelectedGoal ? (
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <div className="objective-list-goal-container">
                    <label className="objective-list-goal-header">
                      {t('formulary.goal_description')}
                    </label>
                    <label className="objective-description">
                      {renderGoalDescription()}
                    </label>
                  </div>
                </Grid.Column>
              ) : null}
            </Grid.Row>
            {showSelectedGoal ? (
              <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <div className="form-group">
                    <label className="">{t('formulary.primary_domain')}</label>
                    <label className="act-inputs form-control primary-goal-container">
                      {renderPrimaryPolicy()}
                    </label>
                    <small className="form-text text-muted">
                      {t('formulary.primary_policy_note')}
                    </small>
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  {renderObjectiveDomainOne()}
                </Grid.Column>
              </Grid.Row>
            ) : null}

            {showSelectedGoal ? (
              <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <div className="form-group">
                    <label className="">
                      {t('formulary.secondary_policy')}
                    </label>
                    <label className="act-inputs form-control primary-goal-container">
                      {renderSecondaryPolicy()}
                    </label>
                    <small className="form-text text-muted">
                      {t('formulary.secondary_policy_note')}
                    </small>
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  {renderObjectiveDomainTwo()}
                </Grid.Column>
              </Grid.Row>
            ) : null}
          </Grid>

          <div className="model-buttons">
            <Button
              className="modal-cancel"
              type="button"
              onClick={() => toggle()}
            >
              {t('actions.cancel')}
            </Button>
            <Button
              content={t('actions.create')}
              type="submit"
              className="modal-proceed"
              loading={duplicateActLoading}
              disabled={duplicateActLoading || goalCheckBlocks}
            />
          </div>
        </AvForm>
      )}
    </div>
  );
};

class OwnedActivities extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      available: false,
      goalsState: '',
      matchingDomains: false,
      notMatchingDomains: false,
      goalsPolicyMatching: [],
      duplicate: true,
      singleData: '',
    };
  }

  // the activity's own manager lands on its goal step, as before; anyone else
  // (a program manager opening a linked activity) gets the activity overview
  getActivityHref(data) {
    return isOwnActivity(data, this.props.user)
      ? `/activities/${data.id}/goal`
      : `/activities/${data.id}`;
  }

  renderLinkedActivityMenu(data) {
    const { t, user } = this.props;
    const {
      notMatchingDomains,
      matchingDomains,
      goalsPolicyMatching,
      singleData,
      available,
    } = this.state;
    return (
      <div className="owned">
        <Dropdown
          icon="ellipsis vertical"
          direction="left"
          inline
          selectOnBlur={false}
        >
          <Dropdown.Menu>
            <Dropdown.Item
              as="a"
              href={`/activity/${data.id}/preview`}
              target="_blank"
            >
              <div className="black-text">{t('actions.view_report')}</div>
            </Dropdown.Item>
            {isOwnActivity(data, user) ? (
              <FeatureWrapper
                featureName="activity_participants"
                children={
                  <Dropdown.Item
                    as="a"
                    href={`/activity/${data.id}/participants`}
                  >
                    <div className="black-text">
                      {t('activity.home.owned.view_team')}
                    </div>
                  </Dropdown.Item>
                }
              />
            ) : null}
            {isOwnActivity(data, user) ? (
              <FeatureWrapper
                featureName="duplicate_activity"
                children={
                  data.statusId === 2 || data.statusId === 3 ? (
                    data.activityPlanTypeId === 1 ? (
                      <DuplicateModal
                        notMatchingDomains={notMatchingDomains}
                        matchingDomains={matchingDomains}
                        goalsPolicyMatching={goalsPolicyMatching}
                        {...this.props}
                        data={singleData}
                        available={available}
                        trigger={
                          <Dropdown.Item
                            className="dropdown-customItem"
                            onClick={() =>
                              this.checkGoalAvailableForDuplication(data)
                            }
                          >
                            <div className="black-text">
                              {t('activity.home.owned.duplicate')}
                            </div>
                          </Dropdown.Item>
                        }
                      />
                    ) : null
                  ) : null
                }
              />
            ) : null}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  getIcon() {
    const { order } = this.props;
    if (order.owned === 'asc') {
      return 'sort up';
    } else {
      return 'sort down';
    }
  }

  renderColumns() {
    const { user, sortOwnedActivities, attributeName, t, i18n } = this.props;
    let name = attributeName.owned;
    const {
      notMatchingDomains,
      matchingDomains,
      goalsPolicyMatching,
      singleData,
      available,
      currentPage,
    } = this.state;
    return [
      {
        title: (
          <div className="sort-icon">
            <div className="lib-header">{t('common.activity_name')}</div>
            <Icon
              className="icon-adjustment"
              name={name === 'name' ? this.getIcon() : 'sort'}
              onClick={(value) => sortOwnedActivities('name')}
            />
          </div>
        ),
        render: (data, ctx) =>
          renderActivityName(data, ctx, this.getActivityHref(data), {
            t,
            user,
            isManagedList: true,
          }),
      },
      {
        className: 'activity-list-table__col--type',
        title: t('common.type'),
        render: (data, ctx) => renderActivityTypeCell(data, ctx, t),
      },
      {
        className: 'activity-list-table__col--date',
        title: (
          <div className="sort-icon">
            <div>{t('common.date_created')}</div>
            <Icon
              name={name === 'createdDateTime' ? this.getIcon() : 'sort'}
              className="icon-adjustment"
              onClick={(value) => sortOwnedActivities('createdDateTime')}
            />
          </div>
        ),
        render: (data) => {
          return formatListDate(data.createdDateTime, i18n.language);
        },
      },
      {
        className: 'activity-list-table__col--dates',
        title: (
          <div className="sort-icon">
            <div>{t('activity.home.activity_dates')}</div>
            <Icon
              className="icon-adjustment"
              name={name === 'eventStartDate' ? this.getIcon() : 'sort'}
              onClick={(value) => sortOwnedActivities('eventStartDate')}
            />
          </div>
        ),
        render: (data) => renderActivityDates(data, i18n.language, t),
      },
      {
        className: 'activity-list-table__col--menu',
        title: '',
        render: (data, ctx) => {
          // inside a program block, or a search result from one of the
          // viewer's programs that someone else manages
          if (ctx.level > 0 || !isOwnActivity(data, user)) {
            return this.renderLinkedActivityMenu(data);
          }
          return (
            <div className="owned">
              <Dropdown
                icon="ellipsis vertical"
                direction="left"
                inline
                selectOnBlur={false}
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    as="a"
                    href={`/activity/${data.id}/preview`}
                    target="_blank"
                  >
                    <div className="black-text">{t('actions.view_report')}</div>
                  </Dropdown.Item>
                  {data.statusId === 3 && user.role === 'guest' ? null : (
                    <FeatureWrapper
                      featureName="activity_participants"
                      children={
                        <Dropdown.Item
                          as="a"
                          href={`/activity/${data.id}/participants`}
                        >
                          <div className="black-text">
                            {t('activity.home.owned.view_team')}
                          </div>
                        </Dropdown.Item>
                      }
                    />
                  )}

                  <FeatureWrapper
                    featureName="duplicate_activity"
                    children={
                      data.statusId === 2 || data.statusId === 3 ? (
                        <>
                          {data.activityPlanTypeId === 1 ? (
                            <DuplicateModal
                              notMatchingDomains={notMatchingDomains}
                              matchingDomains={matchingDomains}
                              goalsPolicyMatching={goalsPolicyMatching}
                              {...this.props}
                              data={singleData}
                              available={available}
                              trigger={
                                <Dropdown.Item
                                  className="dropdown-customItem"
                                  onClick={() =>
                                    this.checkGoalAvailableForDuplication(data)
                                  }
                                >
                                  <div className="black-text">
                                    {t('activity.home.owned.duplicate')}
                                  </div>
                                </Dropdown.Item>
                              }
                            />
                          ) : null}
                        </>
                      ) : null
                    }
                  />

                  <FeatureWrapper
                    featureName="group_activities"
                    children={
                      <AddToGroup
                        {...this.props}
                        data={data}
                        currentPage={currentPage}
                        trigger={
                          <Dropdown.Item
                            onClick={(e) => stopPropagation(e)}
                            onFocus={(e) => stopPropagation(e)}
                          >
                            <div className="black-text">
                              {data.projectGroupId === null
                                ? t('activity.home.owned.add_to_group')
                                : t('activity.home.owned.change_group')}
                            </div>
                          </Dropdown.Item>
                        }
                      />
                    }
                  />

                  {data.projectGroupId !== null ? (
                    <GroupUnAssign
                      {...this.props}
                      data={data}
                      page={currentPage}
                      trigger={
                        <Dropdown.Item>
                          <div className="black-text">
                            {t('activity.home.owned.remove_from_group')}
                          </div>
                        </Dropdown.Item>
                      }
                    />
                  ) : null}

                  {data.statusId === 1 ? (
                    data.parentId ? null : (
                      <ActivityDelete
                        activity={data}
                        page={currentPage}
                        {...this.props}
                        trigger={
                          <Dropdown.Item className="dropdown-customItem">
                            <div className="remove-activity">
                              {t('actions.remove')}
                            </div>
                          </Dropdown.Item>
                        }
                      />
                    )
                  ) : null}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    ];
  }

  async componentDidMount() {
    const { getAllGoals, getPolicies, getOutcomes } = this.props;

    await Promise.all([getAllGoals(), getPolicies(), getOutcomes()]);
  }

  async checkGoalAvailableForDuplication(data) {
    this.setState(duplicationGoalState(this.props.goals, data));
  }

  pageChange(page) {
    const {
      getOwnActivities,
      filter,
      actType,
      group,
      setPage,
      attributeName,
      order,
      searchQuery,
      perPage,
    } = this.props;
    setPage(page);
    getOwnActivities(
      filter.owned,
      actType.owned,
      group.owned,
      page,
      perPage,
      attributeName.owned,
      order.owned,
      searchQuery.owned
    );
  }

  render() {
    const { data, currentPage } = this.props;

    return (
      <ActivityListTable
        columns={compact(this.renderColumns())}
        currentUserId={this.props.user.id}
        data={data.docs}
        getRowHref={(item) => this.getActivityHref(item)}
        onPageChange={(page) => this.pageChange(page)}
        page={currentPage}
        noOfPages={data.pages}
      />
    );
  }
}

class NewActivities extends PureComponent {
  constructor(props) {
    super(props);
    const { t, i18n } = this.props;

    this.state = {
      columns: [
        {
          width: 5,
          title: <div className="lib-header">{t('common.name')}</div>,
          render: (data) => {
            return (
              <div className="activity-name">
                <div
                  className={`circle circle-bottom activity-${getActivityStatus(
                    data.statusId
                  )}`}
                />
                <label>{data.name ? data.name : ''}</label>
              </div>
            );
          },
        },
        {
          width: 1,
          title: t('common.type'),
          render: (data) => {
            const actType = getActivityType(data);
            return actType.type;
          },
        },
        {
          width: 2,
          title: t('common.owner'),
          textAlign: 'left',
          render: (data) => {
            return data.owner ? data.owner.name : '';
          },
        },
        {
          width: 2,
          title: t('common.created'),
          render: (data) => {
            return new Intl.DateTimeFormat(i18n.language, {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
            }).format(new Date(data.createdDateTime));
          },
        },
        {
          width: 2,
          title: t('common.updated'),
          render: (data) => {
            return new Intl.DateTimeFormat(i18n.language, {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
            }).format(new Date(data.lastEditedDateTime));
          },
        },
        {
          width: 4,
          title: '',
          render: (data) => {
            return (
              <div className="activity-actions">
                <Button
                  content={t('actions.accept')}
                  type="submit"
                  className="Primary-Button"
                  onClick={() => this.acceptAct(data.id, true)}
                />
                <label
                  onClick={() => this.acceptAct(data.id, false)}
                  className="reject-text reject"
                >
                  {t('actions.reject')}
                </label>
              </div>
            );
          },
          textAlign: 'center',
        },
      ],
      currentPage: 1,
    };
  }

  acceptAct(projectId, accept) {
    const { acceptInvitation } = this.props;
    acceptInvitation(projectId, accept);
  }

  pageChange(page) {
    const { getInvitations } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        getInvitations(page);
      }
    );
  }

  render() {
    const { currentPage, columns } = this.state;
    const { t, data } = this.props;

    return (
      <CustomTable
        header
        columns={compact(columns)}
        data={data.docs}
        customClass="home-activity tbody-hover"
        pagination
        handlePaginationChange={(page) => this.pageChange(page)}
        page={currentPage}
        noOfPages={data.pages}
        keyExtractor={(item, index) => item.id}
      />
    );
  }
}

const steps = (t) => [
  {
    target: '.header-title-text',
    content: t('activity.home.steps.step_1'),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.add-activity',
    content: t('activity.home.steps.step_2'),
    placement: 'left',
  },
  {
    target: '.owned-activities-container',
    content: t('activity.home.steps.step_3'),
    placement: 'top',
  },
  {
    target: '.activities-filter-container',
    content: t('activity.home.steps.step_4'),
    placement: 'left',
  },
];

const options = (t) => [
  {
    key: 'Ongoing',
    text: <>{t('activity_status.ongoing_activities')}</>,
    value: 'ongoing',
  },
  {
    key: 'Completed',
    text: <>{t('activity_status.completed_activities')}</>,
    value: 'completed',
  },
  {
    key: 'All Activities',
    text: <>{t('activity_status.all_activities')}</>,
    value: 'all',
  },
];

const act_type_options = (t) => [
  {
    key: 'All',
    text: <>{t('activity_type.all_types')}</>,
    value: 'all',
  },
  {
    key: 'Single',
    text: <>{t('activity_type.single')}</>,
    value: 'single',
  },
  {
    key: 'Grant',
    text: <>{t('activity_type.grant')}</>,
    value: 'grant',
  },
  {
    key: 'Festival',
    text: <>{t('activity_type.festival')}</>,
    value: 'festival',
  },
  {
    key: 'Multi Activity',
    text: <>{t('activity_type.multi_activity')}</>,
    value: 'multi-activity',
  },
  {
    key: 'Linked',
    text: <>{t('activity_type.linked')}</>,
    value: 'linked',
  },
];

class ActivityHome extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        owned: 'ongoing',
        invited: 'ongoing',
      },
      actType: {
        owned: 'all',
        invited: 'all',
      },
      infoSteps: false,
      group: {
        owned: 'null',
      },
      perPage: 10,
      ownedActivitiesCurrentPage: 1,
      invitedActivitiesCurrentPage: 1,
      order: {
        owned: 'desc',
        invited: 'desc',
      },
      attributeName: {
        owned: 'createdDateTime',
        invited: 'createdDateTime',
      },
      searchQuery: {
        owned: null,
        invited: null,
      },
      defaultPage: 1,
    };
  }

  async componentDidMount() {
    const {
      clearCurrentActivity,
      getInvitations,
      getUserActivityGroups,
      user: { options },
      user,
    } = this.props;

    try {
      if (!user.onboardingOption.activityTips) {
        this.setState({
          infoSteps: true,
        });
      }
      getInvitations(this.state.defaultPage);
      getUserActivityGroups();

      clearCurrentActivity();
      if (
        !isEmpty(options['activity-filter']) &&
        !isEmpty(options['activity-type-filter']) &&
        !isEmpty(options['activity-group-filter'])
      ) {
        this.setFilterOnUser(
          'owned',
          options['activity-filter'].owned,
          options['activity-type-filter'].owned,
          options['activity-group-filter'].owned
        );
        this.setFilterOnUser(
          'invited',
          options['activity-filter'].invited,
          options['activity-type-filter'].invited
        );
      } else {
        const { filter, actType, group } = this.state;
        this.setFilterOnUser('owned', filter.owned, actType.owned, group.owned);
        this.setFilterOnUser('invited', filter.invited, actType.invited);
      }
    } catch (error) {
      // console.error('ActivityHome -> componentDidMount -> error', error);
    }
  }

  componentDidUpdate() {
    const { visibleTips, setSidebarType, setVisibleTips } = this.props;

    if (visibleTips) {
      setSidebarType(SIDEBAR_TYPES[0], false);
      setVisibleTips(false);
      // check help panel "show me around" btn clicked <- block in other updating statuses
      this.setState({ infoSteps: visibleTips });
    }
  }

  setFilterOnUser(type, filter, actType, group) {
    let {
      helpTips,
      user: { options },
      getOwnActivities,
      getInvitedActivities,
    } = this.props;

    if (isEmpty(options['activity-filter'])) {
      options['activity-filter'] = {};
    }
    if (isEmpty(options['activity-type-filter'])) {
      options['activity-type-filter'] = {};
    }
    if (isEmpty(options['activity-group-filter'])) {
      options['activity-group-filter'] = {};
    }

    options['activity-filter'][type] = filter;
    options['activity-type-filter'][type] = actType;
    options['activity-group-filter'][type] = group;

    this.setState(
      {
        filter: options['activity-filter'],
        actType: options['activity-type-filter'],
        group: options['activity-group-filter'],
      },
      () => {
        switch (type) {
          case 'owned':
            getOwnActivities(
              filter,
              actType,
              group,
              this.state.defaultPage,
              this.state.perPage,
              this.state.attributeName.owned,
              this.state.order.owned,
              this.state.searchQuery.owned
            );
            this.ownedActivitiesSetPage(this.state.defaultPage);
            break;
          case 'invited':
            getInvitedActivities(
              filter,
              actType,
              this.state.defaultPage,
              this.state.perPage,
              this.state.attributeName.invited,
              this.state.order.invited,
              this.state.searchQuery.invited
            );
            this.invitedActivitiesSetPage(this.state.defaultPage);
            break;
          default:
            break;
        }
        helpTips(options);
      }
    );
  }

  getJoyRide(data) {
    const { user, setUserOnboardingOption, setVisibleTips } = this.props;
    const { type } = data;

    if (type === 'tour:end') {
      this.setState(
        {
          infoSteps: false,
        },
        () => {
          if (!user.onboardingOption.activityTips) {
            // only trigger for new user/ users not toured whole trip
            user.onboardingOption.activityTips = true;
            setUserOnboardingOption(user); // save in db
          }
          setVisibleTips(false); // hide help panel and off the onboarding flow in sidebar
        }
      );
    }
  }

  orderBy(value) {
    if (value === 'asc') {
      return 'desc';
    } else {
      return 'asc';
    }
  }

  orderByInvited(value) {
    if (value === 'asc') {
      return 'desc';
    } else {
      return 'asc';
    }
  }

  getOrder(value, name) {
    if (name !== this.state.attributeName.owned) {
      return this.orderBy('desc');
    } else {
      return this.orderBy(value);
    }
  }

  getInvitedOrder(value, name) {
    if (name !== this.state.attributeName.invited) {
      return this.orderByInvited('desc');
    } else {
      return this.orderByInvited(value);
    }
  }

  async sortInvitedActivities(value) {
    const { actType, defaultPage, filter, order, attributeName } = this.state;
    let { getInvitedActivities } = this.props;
    let invitedOrder = this.getInvitedOrder(order.invited, value);

    await this.setState(
      {
        order: {
          ...order,
          invited: invitedOrder,
        },
        attributeName: { ...attributeName, invited: value },
      },
      async () => {
        await getInvitedActivities(
          filter.invited,
          actType.invited,
          defaultPage,
          this.state.perPage,
          this.state.attributeName.invited,
          this.state.order.invited,
          this.state.searchQuery.invited
        );
        //pagination
        this.invitedActivitiesSetPage(this.state.defaultPage);
      }
    );
  }

  async sortOwnedActivities(value) {
    const { actType, group, defaultPage, filter, order, attributeName } =
      this.state;
    let { getOwnActivities } = this.props;
    let getOrder = this.getOrder(order.owned, value);

    await this.setState(
      {
        order: {
          ...order,
          owned: getOrder,
        },
        attributeName: {
          ...attributeName,
          owned: value,
        },
      },
      async () => {
        await getOwnActivities(
          filter.owned,
          actType.owned,
          group.owned,
          defaultPage,
          this.state.perPage,
          this.state.attributeName.owned,
          this.state.order.owned,
          this.state.searchQuery.owned
        );
        this.ownedActivitiesSetPage(this.state.defaultPage);
      }
    );
  }

  renderGroups() {
    const { projectGroup, t } = this.props;
    const groups = map(projectGroup, (item, i) => ({
      key: item.id,
      value: String(item.id),
      text: item.name,
    }));
    groups.unshift({
      key: 'null',
      value: 'null',
      text: t('activity.home.no_groups'),
    });
    return groups;
  }

  ownedActivitiesSetPage = (page) =>
    this.setState({ ownedActivitiesCurrentPage: page });

  invitedActivitiesSetPage = (page) =>
    this.setState({ invitedActivitiesCurrentPage: page });

  // clears one list's search without touching the other's
  resetComponent = (type) =>
    this.setState((prev) => ({
      searchQuery: { ...prev.searchQuery, [type]: null },
    }));

  handleSearchChange = async (e, { value }) => {
    const { actType, group, defaultPage, filter } = this.state;
    let { getOwnActivities } = this.props;

    this.setState(
      {
        searchQuery: { ...this.state.searchQuery, owned: value },
      },
      async () => {
        if (this.state.searchQuery.owned.length < 1) {
          this.resetComponent('owned');
        }
        await getOwnActivities(
          filter.owned,
          actType.owned,
          group.owned,
          defaultPage,
          this.state.perPage,
          this.state.attributeName.owned,
          this.state.order.owned,
          this.state.searchQuery.owned
        );
        //pagination number
        this.ownedActivitiesSetPage(this.state.defaultPage);
      }
    );
  };

  handleSearchInviteChange = async (e, { value }) => {
    const { actType, defaultPage, filter } = this.state;
    let { getInvitedActivities } = this.props;
    this.setState(
      {
        searchQuery: { ...this.state.searchQuery, invited: value },
      },
      async () => {
        if (this.state.searchQuery.invited.length < 1) {
          this.resetComponent('invited');
        }
        await getInvitedActivities(
          filter.invited,
          actType.invited,
          defaultPage,
          this.state.perPage,
          this.state.attributeName.invited,
          this.state.order.invited,
          this.state.searchQuery.invited
        );
        this.invitedActivitiesSetPage(this.state.defaultPage);
      }
    );
  };

  render() {
    const { t } = this.props;
    const {
      ownLoading,
      ownActivities,
      invLoading,
      invitedActivities,
      newInvLoading,
      invitations,
      user,
      projectGroup,
    } = this.props;

    const {
      filter,
      actType,
      infoSteps,
      group,
      ownedActivitiesCurrentPage,
      invitedActivitiesCurrentPage,
    } = this.state;

    return (
      <Grid.Row>
        {user.organisationId ? (
          <Grid.Column width={16} className="p-0">
            <FeatureWrapper
              featureName="create_activity"
              children={<ActivityCreate {...this.props} />}
            />
          </Grid.Column>
        ) : null}
        <Grid.Column width={16} className="p-0">
          {invitations.docs && invitations.docs.length ? (
            <CustomSegment
              title={t('activity.home.new_invitations')}
              extraMargin
            >
              <Segment
                className="content-segment content-segment-bg"
                loading={newInvLoading}
              >
                <NewActivities data={invitations} {...this.props} />
              </Segment>
            </CustomSegment>
          ) : null}
          <FeatureWrapper
            featureName="owned_activities"
            children={
              <CustomSegment
                title={t('common.managed_activities')}
                className="Managed_Activities"
                subChild={
                  <div className="sub-child-segment">
                    <Search
                      className="search-bar-custom"
                      placeholder={t('activity.home.search_by_name')}
                      showNoResults={false}
                      onSearchChange={debounce(this.handleSearchChange, 500, {
                        leading: true,
                      })}
                    />
                    {/*
                     * Note: activities-filter-container class name used for help tip showing
                     * (don't change it or remove it)
                     */}
                    <div className="activities-filter-container manage-activity-drop">
                      {/* hidden until the user has a group — but kept while a
                          group filter is still applied, so it can be cleared */}
                      {!isEmpty(projectGroup) || group.owned !== 'null' ? (
                        <span className="activities-filter">
                          <Dropdown
                            direction="left"
                            inline
                            selectOnBlur={false}
                            options={this.renderGroups()}
                            value={group.owned}
                            onChange={(e, { value }) =>
                              this.setFilterOnUser(
                                'owned',
                                filter.owned,
                                actType.owned,
                                value
                              )
                            }
                          />
                        </span>
                      ) : null}
                      <span className="activities-filter">
                        <Dropdown
                          direction="left"
                          inline
                          selectOnBlur={false}
                          options={act_type_options(t)}
                          value={actType.owned}
                          onChange={(e, { value }) =>
                            this.setFilterOnUser(
                              'owned',
                              filter.owned,
                              value,
                              group.owned
                            )
                          }
                        />
                      </span>
                      <span className="activities-filter">
                        <Dropdown
                          direction="left"
                          inline
                          selectOnBlur={false}
                          options={options(t)}
                          value={filter.owned}
                          onChange={(e, { value }) =>
                            this.setFilterOnUser(
                              'owned',
                              value,
                              actType.owned,
                              group.owned
                            )
                          }
                        />
                      </span>
                      <div className="menu-dropdown">
                        <Dropdown
                          icon="ellipsis vertical"
                          direction="left"
                          inline
                          selectOnBlur={false}
                        >
                          <Dropdown.Menu>
                            <Dropdown.Item className="dropdown-customItem">
                              <ManageGroup
                                {...this.props}
                                {...this.state}
                                setActivityGroupFilter={(value) =>
                                  this.setFilterOnUser(
                                    'owned',
                                    filter.owned,
                                    actType.invited,
                                    value
                                  )
                                }
                              />
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                }
                extraMargin
              >
                <Segment
                  /*
                   * Note:  owned-activities-container class name used for help tip showing class name (don't change it or remove it)
                   */
                  className="content-segment content-segment-bg owned-activities-container"
                  loading={ownLoading}
                >
                  {ownActivities.docs && ownActivities.docs.length ? (
                    <OwnedActivities
                      data={ownActivities}
                      currentPage={ownedActivitiesCurrentPage}
                      setPage={this.ownedActivitiesSetPage}
                      sortOwnedActivities={(value) =>
                        this.sortOwnedActivities(value)
                      }
                      {...this.state}
                      {...this.props}
                    />
                  ) : (
                    <EmptyContainer msg={t('empty_message.no_activities')} />
                  )}
                </Segment>
              </CustomSegment>
            }
          />
          <CustomSegment
            title={t('common.invited_activities')}
            className="Invited_Activities"
            subChild={
              <div className="sub-child-segment">
                <Search
                  className="search-bar-custom"
                  placeholder={t('actions.search')}
                  showNoResults={false}
                  onSearchChange={debounce(this.handleSearchInviteChange, 500, {
                    leading: true,
                  })}
                />
                <div className="activities-filter-container manage-activity-drop">
                  <span className="activities-filter">
                    <Dropdown
                      direction="left"
                      inline
                      selectOnBlur={false}
                      options={act_type_options(t)}
                      value={actType.invited}
                      onChange={(e, { value }) =>
                        this.setFilterOnUser('invited', filter.invited, value)
                      }
                    />
                  </span>
                  <span className="activities-filter">
                    <Dropdown
                      direction="left"
                      inline
                      selectOnBlur={false}
                      options={options(t)}
                      value={filter.invited}
                      onChange={(e, { value }) =>
                        this.setFilterOnUser('invited', value, actType.invited)
                      }
                    />
                  </span>
                </div>
              </div>
            }
            extraMargin
          >
            <Segment
              className="content-segment content-segment-bg"
              loading={invLoading}
            >
              {invitedActivities.docs && invitedActivities.docs.length ? (
                <InvitedActivities
                  currentPage={invitedActivitiesCurrentPage}
                  setPage={this.invitedActivitiesSetPage}
                  sortInvitedActivities={(value) =>
                    this.sortInvitedActivities(value)
                  }
                  data={invitedActivities}
                  {...this.state}
                  {...this.props}
                />
              ) : (
                <EmptyContainer msg={t('empty_message.no_activities')} />
              )}
            </Segment>
          </CustomSegment>
        </Grid.Column>
        <Joyride
          autoStart
          callback={(data) => this.getJoyRide(data)}
          run={infoSteps}
          steps={steps(t)}
          continuous
          disableOverlayClose={true} // disable overlay close <- need to go whole trip
          disableCloseOnEsc={true}
          tooltipComponent={Tooltip}
          beaconComponent={BeaconComponent}
          scrollToFirstStep
          disableScrolling={!isMobile} // disable scroll in web view <- to resolve wrong target at help panel in web view
        />
      </Grid.Row>
    );
  }
}

class ManageGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { t } = this.props;
    const { modal } = this.state;

    return (
      <div className="add-goal">
        <Modal
          onOpen={() => this.toggle()}
          onClick={(e) => stopPropagation(e)}
          onFocus={(e) => stopPropagation(e)}
          trigger={<div>{t('activity.home.manage_group.trigger')}</div>}
          size="large"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="group-management"
        >
          <Modal.Header>
            <div className="header-goal-duplicate">
              {t('activity.home.manage_group.modal_title')}
            </div>
          </Modal.Header>
          <Modal.Content>
            <ManageGroupForm
              manageModalToggle={() => this.toggle()}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class ManageGroupForm extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      columns: [
        {
          width: 5,
          title: <div>{t('common.group_name')}</div>,
          render: (data) => {
            return <div>{data.name}</div>;
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          width: 5,
          title: (
            <div>{t('activity.home.manage_group_form.activity_count')}</div>
          ),
          render: (data) => {
            const activityCount = size(data.projectGroup);

            return <div>{activityCount}</div>;
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          width: 5,
          title: <div>{t('common.date_created')}</div>,
          render: (data) => {
            return (
              <div>
                {' '}
                {data.createdAt
                  ? moment(data.createdAt).format('ddd DD MMM YYYY')
                  : '-'}
              </div>
            );
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
        {
          width: 1,
          title: <div>{t('activity.home.manage_group_form.actions')}</div>,
          render: (data) => {
            return (
              <div className="actions-manage-group">
                <RenameGroup {...this.props} data={data} />

                <RemoveGroup {...this.props} data={data} />
              </div>
            );
          },
          textAlign: isBrowser || isTablet ? 'centre' : null,
        },
      ],
    };
  }

  render() {
    const { t, projectGroup, projectGroupLoading } = this.props;
    const { columns } = this.state;

    return (
      <div loading={projectGroupLoading} disabled={projectGroupLoading}>
        {projectGroup.length ? (
          <CustomTable
            header
            columns={columns}
            data={projectGroup}
            keyExtractor={(item, index) => item.id}
            customClass="group-management"
          />
        ) : (
          <EmptyContainer
            msg={t('activity.home.manage_group_form.no_groups')}
          />
        )}
      </div>
    );
  }
}

class RenameGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      getUserActivityGroups,
    }));
  }

  async handleValidSubmit(event, values) {
    const { t } = this.props;
    try {
      const { updateProjectGroupRename, data, user } = this.props;

      await updateProjectGroupRename(data.id, values, user.id);
      this.toggle();
    } catch (error) {
      NotificationManager.error(
        t('activity.home.rename_group.notificationBody'),
        t('activity.home.rename_group.notification_title')
      );
    }
  }

  render() {
    const { modal } = this.state;
    const { t, data } = this.props;

    return (
      <div className="add-goal">
        <Modal
          onOpen={() => this.toggle()}
          trigger={
            <div className="rename-title">
              {t('activity.home.rename_group.trigger')}
            </div>
          }
          size="tiny"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
        >
          <Modal.Header>
            <div className="header-goal-duplicate">
              {t('activity.home.rename_group.modal_title')}
            </div>
          </Modal.Header>

          <Modal.Content>
            <AvForm
              ref={(c) => (this.form = c)}
              onValidSubmit={(event, values) =>
                this.handleValidSubmit(event, values)
              }
              autoComplete="off"
              model={data}
            >
              <AvField
                label={t('common.group_name')}
                className="org-inputs"
                name="name"
                type="text"
                validate={{
                  required: {
                    value: true,
                    errorMessage: t(
                      'activity.home.rename_group.group_name_required'
                    ),
                  },
                }}
                autoComplete="off"
              />

              <div className="model-buttons">
                <Button
                  className="modal-cancel"
                  type="button"
                  onClick={() => this.toggle()}
                >
                  {t('actions.cancel')}
                </Button>
                <Button
                  content={t('actions.save')}
                  type="submit"
                  className="modal-proceed"
                  // loading={groupRenameLoading}
                  // disabled={groupRenameLoading}
                />
              </div>
            </AvForm>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class RemoveGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async deleteProjectGroup(id) {
    const { t } = this.props;
    try {
      const {
        deleteProjectGroup,
        user,
        filter,
        actType,
        manageModalToggle,
        setActivityGroupFilter,
      } = this.props;
      let page = 1;

      const currentSelectedGroupId = Number(
        user.options['activity-group-filter']['owned']
      );
      if (
        user &&
        user.options &&
        user.options['activity-group-filter'] &&
        user.options['activity-group-filter']['owned'] &&
        currentSelectedGroupId === id
      ) {
        setActivityGroupFilter('null');
      }

      await deleteProjectGroup(
        id,
        user.id,
        filter,
        actType,
        page,
        currentSelectedGroupId
      );
      this.toggle();
      manageModalToggle();
    } catch (error) {
      NotificationManager.error(
        t('activity.home.remove_group.notification_body'),
        t('activity.home.remove_group.notification_title')
      );
    }
  }

  render() {
    const { t, data } = this.props;
    const { modal } = this.state;

    return (
      <div className="add-goal">
        <Modal
          onOpen={() => this.toggle()}
          trigger={
            <div className="remove-title">
              {t('activity.home.remove_group.trigger')}
            </div>
          }
          size="tiny"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
        >
          <Modal.Header>
            <div className="header-goal-duplicate">
              {t('activity.home.remove_group.modal_title', {
                groupName: data.name,
              })}
            </div>
          </Modal.Header>
          <Modal.Content>
            {t('activity.home.remove_group.confirmation')}
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => this.toggle()} className="modal-cancel">
              {t('actions.no')}
            </Button>
            <Button
              onClick={() => this.deleteProjectGroup(data.id)}
              className="modal-proceed"
              content={t('actions.yes')}
              // loading={deleteProjectGroupLoading}
              // disabled={deleteProjectGroupLoading}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  // set organisation parent activity status

  return {
    ...state.activity,
    user: state.authentication.user,
    actPlanTypes: state.extra.actPlanTypes,
    projectGroup: state.activity.projectGroup,
    goals: state.activity.goals,
    groupRenameLoading: state.activity.groupRenameLoading,
    groupAddLoading: state.activity.groupAddLoading,
    deleteProjectGroupLoading: state.activity.deleteProjectGroupLoading,
    showModal: state.activity.showModal,
    duplicateActLoading: state.activity.duplicateActLoading,
    policies: state.extra.policies,
    outcomes: state.extra.outcomes,
    visibleTips: state.sidebar.isVisibleTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getInvitations,
      getOwnActivities,
      getInvitedActivities,
      clearCurrentActivity,
      acceptInvitation,
      postActivity,
      deleteActivity,
      helpTips,
      getUserActivityGroups,
      postDuplicateActivity,
      getDuplicateParentInfo,
      getAllGoals,
      getPolicies,
      getOutcomes,
      postActivityGroup,
      deleteProjectGroup,
      updateProjectGroupRename,
      setUserOnboardingOption,
      setVisibleTips,
      setSidebarType,
    },
    dispatch
  );
};

ActivityHome = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivityHome));

RemoveGroup = withTranslation()(RemoveGroup);
RenameGroup = withTranslation()(RenameGroup);
NewActivities = withTranslation()(NewActivities);
ManageGroup = withTranslation()(ManageGroup);
ManageGroupForm = withTranslation()(ManageGroupForm);
InvitedActivities = withTranslation()(InvitedActivities);
ActivityCreate = withTranslation()(ActivityCreate);
DuplicateModal = withTranslation()(DuplicateModal);
OwnedActivities = withTranslation()(OwnedActivities);
GroupForm = withTranslation()(GroupForm);
AddToGroup = withTranslation()(AddToGroup);
GroupUnAssign = withTranslation()(GroupUnAssign);
ActivityDelete = withTranslation()(ActivityDelete);
DuplicateModal = withTranslation()(DuplicateModal);

export {
  ActivityHome as default,
  RemoveGroup,
  RenameGroup,
  NewActivities,
  ManageGroup,
  ManageGroupForm,
  InvitedActivities,
  ActivityCreate,
  ActivityForm,
  OwnedActivities,
  GroupForm,
  AddToGroup,
  GroupUnAssign,
  ActivityDelete,
  DuplicateModal,
  DuplicateForm,
};
